module.exports = {
  FRENCH: "fr",
  ENGLISH: "gb",
};
